import React from "react";
import ReactExport from "react-data-export";
import { format } from "date-fns";
import { convertYYYYMMDDToDate } from "../../utils/date";

const File = ReactExport.ExcelFile;
const Sheet = ReactExport.ExcelFile.ExcelSheet;
const Column = ReactExport.ExcelFile.ExcelColumn;

const Report = ({
    data,
    filename,
    intl,
    clientTypes,
    children }) => (
  <File element={children} filename={filename} fileExtension="xlsx">
    <Sheet data={data} name="Relatório">
      <Column label="cnpj" value="accountCode" />
      <Column label="razao_social" value="accountName" />
      <Column label="nome_fantasia" value="accountAlias" />
      <Column label="estande" value="booth" />
      <Column label="area" value="area" />
      <Column label="contrato" value="opportunity" />
      <Column
        label="data_entrada_contrato"
        value={(col) => col.salesforceCloseDate
          ? format(convertYYYYMMDDToDate(col.salesforceCloseDate), "dd/MM/yyyy")
          : "-"}
      />
      <Column
        label="data_criacao_contrato_portal"
        value={(col) => col.opportunityCreatedAt
          ? format(new Date(col.opportunityCreatedAt), "dd/MM/yyyy")
          : "-"}
      />
      <Column
        label="data_atualizacao_contrato_portal"
        value={(col) => col.opportunityUpdatedAt
          ? format(new Date(col.opportunityUpdatedAt), "dd/MM/yyyy")
          : "-"}
      />
      <Column label="telefone_conta" value="phone" />
      <Column label="email_login" value="mail" />
      <Column label="responsavel_operacional" value="contact" />
      <Column label="email_operacional" value="contactMail" />
      <Column label="email_marketing" value="marketingMail" />
      <Column label="telefone_operacional" value="contactPhone" />
      <Column label="vendedor" value="salesman" />
      <Column
        label="tipo_cliente"
        value={ (col) => clientTypes.filter((pt) =>
          pt.value === col.clientType)[0]?.label }
      />
      <Column label="tipo_usuario" value="userType" />
      <Column label="tipo_contrato" value="contractType" />
      <Column
        label="tipo_cliente_informa"
        value={(col) =>
          intl.formatMessage({ id: col.informaClientType?.toLowerCase() })
        }
      />
      <Column
        label="acessou_o_portal"
        value={(col) => (col.portalAccessed ? "Sim" : "Não")}
      />
      <Column
        label="acessou_o_evento"
        value={(col) => (col.eventAccessed ? "Sim" : "Não")}
      />
      <Column label="email_primeiro_acesso" value="firstEmail" />
      <Column label="credenciais" value="credentialCount" />
      <Column
        label="prestador_servico_associado"
        value={(col) => (col.hasAssociatedServiceProvider ? "Sim" : "Não")}
      />
    </Sheet>
  </File>
);

export default Report;
